var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0Z",
    "data-name": "Path 3632"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#525863",
    d: "M5.4 21.6a3 3 0 0 1-3-3V5.4a3 3 0 0 1 3-3h4.127a1 1 0 0 1 1 1 1.116 1.116 0 0 1-1 1.123h-4a1 1 0 0 0-1 1v12.954a1 1 0 0 0 1 1H18.4a1 1 0 0 0 1-1v-4a1.173 1.173 0 0 1 1.186-1 1 1 0 0 1 1 1v4.127a3 3 0 0 1-3 3Zm10.175-7.521a.709.709 0 0 1-.422-.652v-2.345a10.44 10.44 0 0 0-.565-.014c-1.915 0-5.318.351-6.641 2.707a.682.682 0 0 1-.6.355.662.662 0 0 1-.179-.024.7.7 0 0 1-.51-.677 8.483 8.483 0 0 1 2.281-5.518 8.925 8.925 0 0 1 6.211-2.48V3.11a.7.7 0 0 1 .422-.647.685.685 0 0 1 .753.15l5.055 5.16a.711.711 0 0 1 0 1l-5.055 5.159a.688.688 0 0 1-.753.151Zm.151-4.519a.621.621 0 0 1 .545.625v1.162l3.018-3.077-3.013-3.077V6.36a.625.625 0 0 1-.618.624 7.051 7.051 0 0 0-5.263 1.852 5.821 5.821 0 0 0-1.273 2.042 9.982 9.982 0 0 1 5.422-1.369c.699.001 1.156.053 1.18.053Z",
    "data-name": "Path 2655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.26f6886da011c7eae0c7ba1c3d86eb88.svg";
export { ForwardRef as ReactComponent };